import React from "react";
import InputBaseWithErrorLabel, { type InputBaseProps } from "./WithErrorLabel/InputBaseWithErrorLabel";
import { useValidate } from "formvalidation/hooks";
import { useSemanticUiInputRef } from "utilities/hookutils";

interface Props extends Omit<InputBaseProps, "error"> {
  value: string
  validatorKey: string
  title: string;
  maxLength: number
}

const GenericMandatoryInput = (props: Props) => {
  const { value, validatorKey, title, ...rest } = props;
  const semanticInputRef = useSemanticUiInputRef();

  const validateLength = async (input: string) => {
    if (input.trim().length === 0) {
      return RESX.GeneralWarnings.PleaseFillInThisField;
    }

    return true;
  };

  const validation = useValidate({
    key: validatorKey,
    title: title,
    value: value,
    validate: validateLength,
    ref: semanticInputRef.ref
  });

  return <InputBaseWithErrorLabel
    {...rest}
    fluid
    innerRef={semanticInputRef.refSetter}
    error={validation.error.hasError}
    maxLength={props.maxLength}
    value={props.value}
    onChange={props.onChange}
  />
};

export default GenericMandatoryInput;